export default __webpack_public_path__ + "static/media/logo.298f57c4.png";